import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitEmail = async (email, name) => {
  try {
    const response = await axios.post(`${API}/leads`, {
      name,
      email
    });
    return {
      success: true,
      message: 'Successfully registered for early access!',
      data: response.data
    };
  } catch (error) {
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error('Failed to register. Please try again.');
  }
};

export const getLeadCount = async () => {
  try {
    const response = await axios.get(`${API}/leads/count`);
    return response.data.count;
  } catch (error) {
    console.error('Failed to fetch lead count:', error);
    return 0;
  }
};
